import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'total-consumption-grid-item',
    templateUrl: './total-consumption-grid-item.component.html',
})
export class TotalConsumptionGridItem implements AfterViewInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    averageConsumption: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
    }

    onInfoClick() {
        swal({
            title: 'Year on year total consumption',
            html: '<p style="text-align: left;">This widget compares total consumption year on year.</p>\
            <p style="text-align: left;">It can be viewed by daily or monthly totals.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
